import { createRouter, createWebHistory } from 'vue-router'


        const routes = [
            //<editor-fold defaultstate="collapsed" desc="mod-login">
            {
                path: '/login',
                name: 'login',
                component: () => import(/* webpackChunkName: "mod-login" */ '@/components/login')
            },
            //</editor-fold>
            //<editor-fold defaultstate="collapsed" desc="mod-grant">    
            {
                path: '/grant-list',
                name: 'grant.list',
                component: () => import(/* webpackChunkName: "mod-grant" */ '@/components/grant-list')
//                , children: [
//                    {
//                        path: 'edit/:grantid',
//                        name: 'grant.claim-list',
//                        props: true,
//                        component: () => import(/* webpackChunkName: "mod-grant" */ '@/components/grant-edit/grant-edit-main')
//                    }
//                ]
            },
            {
                path: '/claim-list/:grantid',
                name: 'grant.claim-list',
                props: true,
                component: () => import(/* webpackChunkName: "mod-claim" */ '@/components/claim-list')
                , children: [
                    {
                        path: '/claim-list/:grantid/edit/:claimid',
                        name: 'grant.claim-edit',
                        props: true,
                        component: () => import(/* webpackChunkName: "mod-claim" */ '@/components/claim-edit')
                    }
                ]
            },

            //</editor-fold>
            {
                path: '/',
                name: 'home',
                component: () => {
                    return import(/* webpackChunkName: "mod-grant" */ '@/components/grant-list');
                },
                props: true
            }
        ];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});
router.deepHistory = [];
router.afterEach(function (to, from) {
    router.prevLocation = from;
});

export default router
